import {Component} from "react";
import Glob from "../../libs/Glob.mjs";
import "./AboutPage.css";
import {Button, ButtonGroup} from "reactstrap";
import MailIcon from "../../media/assets/MailIcon.mjs";
import TextLabel from "../../controls/TextLabel.mjs";
import LockIcon from "../../media/assets/LockIcon.mjs";
import LanguageSwitcher from "../../controls/LanguageSwitcher/LanguageSwitcher.mjs";
import appLib from "../../libs/appLib.mjs";

const prefix = 'AboutPage';

const AboutPage = class extends Component {
	constructor(props) {
		super(props);
		this.state = {
			lang: Glob.getLanguage(),
			user: appLib.currentUser()
		};
		this.uid = Glob.generateUid(prefix);
	}
	componentDidMount() {
		Glob.register('Prefs', ()=>{
			const g = Glob.getLanguage();
			if ( g !== this.state.lang ) this.setState({lang:g});
		}, this.uid)
	}
	componentWillUnmount() {
		Glob.deregister(this.uid);
	}
	render() {
		return (
			<div
				className={prefix}
				key={this.state.lang}
				lang={this.state.lang}
			>
				<h2>“<strong>Ollivud</strong>” (Oliveto Sabino)</h2>
				<p lang={"it"}>
					Questa web application è stata sviluppata ed è distribuita a titolo amatoriale e
					completamente gratuito per offrire un servizio diretto agli abitanti di Oliveto.
				</p>
				<p lang={"en"}>
					This web application was developed and is distributed 100% amateur and free of charge
					to directly serve Oliveto Sabino inhabitants.
				</p>
				<p lang={"it"}>
					Nasce nel rione di Via Castiglioni, perché… un informatico non riusciva a ricordare quando buttare l’immondizia.<br />
					L’app si diffonde velocemente, poi con l’avvento della fibra a Oliveto diventa improvvisamente più utile e ancora più diffusa.
				</p>
				<p lang={"en"}>
					It originated in the Castiglioni, because… a computer scientist couldn't remember when to take out the garbage.<br />
					The app spread quickly, then with the advent of fiber connections in Oliveto, it suddenly became more useful and even more widespread.
				</p>
				<p lang={"en"}>Contributions:</p>
				<p lang={"it"}>Contributi:</p>
				<ul>
					<li>Marco B., <span lang={"it"}>sviluppo</span><span lang={"en"}>development</span></li>
					<li>Paola C. &amp; Flavia L., <span lang={"it"}>nome app e primi utenti</span><span lang={"en"}>app name and early birds</span></li>
					<li>Sergio L., <span lang={"it"}>supporto e</span><span lang={"en"}>support and</span> live-cam</li>
					<li lang={"it"}>
						Tutti quelli che —come Massimo, Fabrizio ed altri— hanno in qualche modo offerto il proprio supporto.
					</li>
					<li lang={"en"}>
						The many people —like Massimo, Fabrizio, etc.— who somehow provided their support.
					</li>
				</ul>
				<hr />
				<small lang={"it"}>
					<strong>Nota bene</strong>: il servizio è erogato a titolo amatoriale e gratuito; si declinano ogni garanzia, supporto o responsabilità.
				</small>
				<small lang={"en"}>
					<strong>Please note</strong>: the service is provided “as-is”, amateur and free of charge, without any warranty, support or responsibility.
				</small>
				<hr />
				{ this.state.user && (
					<>
						<ButtonGroup className={"btn-icon"}>
							<Button
								color={"warning"}
								onClick={() => { window.open("mailto:marco@crossbow.it?subject=About "+window.location.host) }}
							>
								<i>
									<MailIcon />
								</i>
								<b>
									<TextLabel value={"Contact developer"} />
								</b>
							</Button>
							<Button
								color={"primary"}
								onClick={ ()=>{ window.location.href = './manager' }}
							>
								<b>
									<TextLabel value={"Management"} />
								</b>
								<i>
									<LockIcon />
								</i>
							</Button>
						</ButtonGroup>
						<hr />
					</>
				) }
				<div style={{margin: "0 auto", width: "fit-content"}}>
					<LanguageSwitcher notitle={true}/>
				</div>
			</div>
		)
	}
}

export default AboutPage;